import ApiClient from './ApiClient';

class TaskBoardsAPI extends ApiClient {
  constructor() {
    super('task_boards', { accountScoped: true });
  }
}

export default new TaskBoardsAPI();
